import { render, staticRenderFns } from "./PoemFormNode.vue?vue&type=template&id=35a85407&scoped=true&"
import script from "./PoemFormNode.vue?vue&type=script&lang=js&"
export * from "./PoemFormNode.vue?vue&type=script&lang=js&"
import style0 from "./PoemFormNode.vue?vue&type=style&index=0&id=35a85407&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a85407",
  null
  
)

export default component.exports